import * as React from 'react';
import type { PropsWithChildren } from 'react';

import type { ValuesFromPremiumHubPageData } from 'bundles/premium-hub/hooks/usePremiumHubPageData';

const PremiumHubPageDataContext = React.createContext<ValuesFromPremiumHubPageData | undefined>(undefined);

type PremiumHubPageDataProviderProps = PropsWithChildren<{ value: ValuesFromPremiumHubPageData }>;

export const PremiumHubPageDataProvider = ({ value, children }: PremiumHubPageDataProviderProps) => (
  <PremiumHubPageDataContext.Provider value={value}>{children}</PremiumHubPageDataContext.Provider>
);

export const usePremiumHubPageDataContext = (): ValuesFromPremiumHubPageData => {
  const context = React.useContext(PremiumHubPageDataContext);
  if (context === undefined) {
    throw new Error('usePremiumHubPageDataContext must be used within a PremiumHubPageDataProvider');
  }
  return context;
};

export const usePremiumHubExperimentValues = () => {
  const { experimentValues } = usePremiumHubPageDataContext();
  return experimentValues;
};

export default PremiumHubPageDataContext;
